import { WidgetId } from 'features/types'
import { LightboxProps } from 'components/visualization/Lightbox/types'

export type Theme = 'light' | 'dark'
export type ToastId = string | number

export enum Page {
  LiveReport = 'LiveReport'
}
export interface UiSlice {
  displayTheme: Theme
  'dashboard/edit'?: any
  toasts: ToastId[]
  dashboardViewLayout: {
    presentationMode: boolean
    pinMode: boolean
    exportMode: boolean
    isFilterDropdownOpen: boolean
  }
  refresh: {
    timestamp: number
    interval: number
    enabled: boolean
    onDemands: Record<WidgetId, number>
  }
  lightbox: {
    slides: LightboxProps['slides']
    defaultIndex: LightboxProps['defaultIndex']
    isOpen: LightboxProps['isOpen']
  }
  // This flag is used to determine which api service to call. (e.g., app-cb or liveReportService)
  page?: Page
  introductionToolTips: {
    labelsIsRead: boolean
    sidePanelIsRead: boolean
  }
}
